import { RequestService } from "../../../../../common/services/RequestService";
import {GET_OFFERS_COUNTS} from "../constants";

export const getOffersCountsRequest = async (
  profileId
) => {
  const response = await RequestService.get(GET_OFFERS_COUNTS.replace("{profile_id}", profileId));
  return response
};
